import { Fragment } from "react";
import { RibbonProps } from "../../Types/CommonElementType";

const Ribbon: React.FC<RibbonProps> = (props) => {
  return (
    <Fragment>
      <div {...props}>{props.children}</div>
    </Fragment>
  );
};

export default Ribbon;
